// BarChart.js
import React, { useRef, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useNavigate } from "react-router-dom";

import filterAndReduceAmountByMonthOnly from "../utilities/filterAndReduceAmountByMonthOnly";
import TotalRevenue from "./TotalRevenue";

// Register the components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ MonthlySalesArray, SoldVoucherList }) => {
  const [monthIndex, setMonthIndex] = useState(0);
  const chartRef = useRef(null);
  const navigate = useNavigate(); // Correct usage of useNavigate hook
  const [gradient, setGradient] = useState(null);

  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Monthly Data",
        data: MonthlySalesArray,
        borderRadius: 20,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
      roundedBars: true, // Enable rounded bars
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: false,
        },
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const month = data.labels[index];
        const filteredMonthData = filterAndReduceAmountByMonthOnly(
          SoldVoucherList,
          index + 1
        );
        navigate(`/TotalRevenue`, {
          state: { monthData: filteredMonthData, monthIndex: index + 1 },
        });
      }
    },
  };

  useEffect(() => {
    const chart = chartRef.current;

    if (chart) {
      const ctx = chart.ctx;
      const gradient = ctx.createLinearGradient(0, 0, 0, 100);
      gradient.addColorStop(0, "#9EDAFC"); // Light Blue at the top
      gradient.addColorStop(1, "#008DDC"); // Dark Blue at the bottom

      // Set the gradient to each data point
      const updatedData = data.datasets[0].data.map(() => gradient);
      chart.data.datasets[0].backgroundColor = updatedData;
      chart.update();
    }
  }, [chartRef]);

  return <Bar ref={chartRef} data={data} options={options} />;
};

export default BarChart;
